import styled from "styled-components";

// make a 2 column grid with one small area and one large area

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-template-areas:
    "sidebar trending trending"
    "sidebar vegetables vegetables"
    "sidebar grains grains"
    "sidebar tubers tubers"
    "sidebar fruits fruits";
  gap: 3rem;
  padding: 3rem;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      "trending"
      "vegetables"
      "grains"
      "tubers"
      "fruits";

    place-items: center;
  }
`;

export const Sidebar = styled.div`
  grid-area: sidebar;
`;

export const Trending = styled.div`
  grid-area: trending;
  display: flex;
  flex-direction: column;
  margin-bottom: 5rem;

  h1 {
    font-size: 2rem;
    font-weight: bold;
    color: #3cc830;
  }

  div {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    flex-direction: row;
  }
`;

export const Vegetables = styled(Trending)`
  grid-area: vegetables;
`;

export const Grains = styled(Trending)`
  grid-area: grains;
`;

export const Tubers = styled(Trending)`
  grid-area: tubers;
`;

export const Fruits = styled(Trending)`
  grid-area: fruits;
`;
